module.exports = __webpack_public_path__ + "static/media/tanjungleban.38153f9d.jpeg";